import {Injectable} from "@angular/core";

@Injectable({ providedIn: 'root' })
export class HtmlHelperService {
  /**
   * Retire toutes les balises HTML
   * @param text
   * @returns {string}
   */
  public static htmlToPlaintext(text) {
    return text ? String(text).replace(/<[^>]+>/gm, '') : '';
  }

  /**
   * Decode l'encodage HTML (&eacute; &nbsp; etc)
   * @param input
   * @returns {string | string | null}
   */
  public static htmlDecode(input) {
    const e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
  }

  /**
   * Remplace les <p>texte</p> et <br/> par des carriage return \n
   * @param html
   */
  public static replacePandBRwithCarriageReturn(html) {
    let text = '';
    const regExpP = /<p\s*>[\S\s]*?<\/p>/gm;
    const _html = String(html).replace(/<br\s*[\/]?>/gim, '\n');
    const _matchesP: RegExpMatchArray = _html.match(regExpP);
    if (_matchesP) {
      _matchesP.forEach(_item => {
        const _itemReplace = _item.replace(/<p>(.*)<\/p>/gim, '$1\n');
        text = `${text}${_itemReplace}`;
      });
    }
    return text;
  }
  /**
   * Transforme du HTML en "plain text"
   * @param {string} htmlText
   * @param {boolean} replacePBRwithCarriageReturn : remplace les <p>...</p> et <br/> par un \n
   */
  public static plainText(htmlText, replacePBRwithCarriageReturn= false) {
    let _html = htmlText;
    if (replacePBRwithCarriageReturn) {
      _html = HtmlHelperService.replacePandBRwithCarriageReturn(htmlText);
      console.log(_html);
    }
    return HtmlHelperService.htmlDecode(HtmlHelperService.htmlToPlaintext(_html));
  }

  constructor() {
  }
}
